// #region Constants

export const ELLIPSE_TYPE     = 'ellipse';
export const RECTANGLE_TYPE   = 'rectangle';
export const POLYGON_TYPE     = 'polygon';

// #endregion Constants

// #region Utilities

export function toShape(type, color, startX, startY, endX, endY, points) {
  let shape = undefined;

  switch (type) {

  case ELLIPSE_TYPE: {
    const x = Math.min(startX, endX);
    const width = Math.abs(startX - endX);
    const y = Math.min(startY, endY);
    const height = Math.abs(startY - endY);

    shape = {
      type:  ELLIPSE_TYPE,
      color: color,
      cx:    x + (width / 2),
      cy:    y + (height / 2),
      rx:    (width / 2),
      ry:    (height / 2)
    }

    break;
  }

  case RECTANGLE_TYPE: {
    shape = {
      type:   RECTANGLE_TYPE,
      color:  color,
      x:      Math.min(startX, endX),
      y:      Math.min(startY, endY),
      width:  Math.abs(startX - endX),
      height: Math.abs(startY - endY)
    };

    break;
  }

  case POLYGON_TYPE: {
    shape = {
      type:   POLYGON_TYPE,
      color:  color,
      points: points
    };
  }
  
  }

  return shape;
}

export function moveShape(shape, dx, dy) {
  switch (shape.type) {

  case ELLIPSE_TYPE: {
    shape.cx = Number(shape.cx) + dx;
    shape.cy = Number(shape.cy) + dy;

    break;
  }

  case RECTANGLE_TYPE: {
    shape.x = Number(shape.x) + dx;
    shape.y = Number(shape.y) + dy;

    break;
  }

  case POLYGON_TYPE: {
    shape.points.forEach(p => {
      p.x = Number(p.x) + dx;
      p.y = Number(p.y) + dy;
    });

    break;
  }

  }
}

// #endregion Utilities